import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Instagram, Youtube } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { termsDocument, privacyDocument } from '../data/legal';
import { LOGO_URL } from '../data/site';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-86" data-mp="36pzblcu4yhj9">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.51a8.16 8.16 0 0 0 4.77 1.52V6.59a4.85 4.85 0 0 1-1.84.1z" data-id="element-87" data-mp="3ucxo5zf4x5bw" />
    </svg>;
}
const socials = [{
  name: 'Instagram',
  href: 'https://www.instagram.com/soycarelizgriman?igsh=MWFpcDMyZjg1ejJscg%3D%3D&utm_source=qr',
  Icon: Instagram
}, {
  name: 'YouTube',
  href: 'https://youtube.com/@carelizgriman?si=sfBZOq9wWIhPjj0e',
  Icon: Youtube
}, {
  name: 'TikTok',
  href: 'https://www.tiktok.com/@soycarelizgriman?_r=1&_t=ZS-96TRRhTFqXE',
  Icon: TikTokIcon
}];
type OpenDoc = 'terms' | 'privacy' | null;
export function Footer() {
  const [openDoc, setOpenDoc] = useState<OpenDoc>(null);
  return <>
      <footer className="border-t border-gold/25 bg-cream px-6 py-14" data-id="element-88" data-mp="3q7llpovzp6kj">
        <div className="mx-auto max-w-3xl text-center" data-id="element-89" data-mp="82ienymgqkhh">
          <img src={LOGO_URL} alt="La Herradura Dorada" className="mx-auto w-28" data-id="element-90" data-mp="81785r1muymo" />

          <div className="mt-8 flex items-center justify-center gap-4" data-id="element-91" data-mp="hstrkao4k40i">
            {socials.map(({
            name,
            href,
            Icon
          }) => <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={`${name} de Careliz Griman`} className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/45 bg-ivory text-gold-dark transition-[color,border-color,transform] duration-200 ease-out hover:-translate-y-0.5 hover:border-gold hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark" data-id="element-92" data-mp="cth01cmb68rl">
                <Icon className="h-[18px] w-[18px]" data-id="element-93" data-mp="18jr2s3yvbvw8" />
              </a>)}
          </div>

          {/* Legal links — clear, legible, tappable */}
          <nav aria-label="Información legal" className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-8" data-id="element-94" data-mp="1clcma85wr8fe">
            <button type="button" onClick={() => setOpenDoc('terms')} className="text-[15px] font-medium text-ink underline decoration-gold/60 decoration-1 underline-offset-4 transition-colors duration-200 hover:text-gold-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark" data-id="element-95" data-mp="1mktpmixota87">
              Términos y Condiciones
            </button>
            <button type="button" onClick={() => setOpenDoc('privacy')} className="text-[15px] font-medium text-ink underline decoration-gold/60 decoration-1 underline-offset-4 transition-colors duration-200 hover:text-gold-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark" data-id="element-96" data-mp="2agybcxutojkj">
              Política de Privacidad
            </button>
          </nav>

          <p className="mx-auto mt-9 max-w-xl text-[14px] leading-relaxed text-ink-muted" data-id="element-97" data-mp="2pcw92kke9vyv">
            La Herradura Dorada es un espacio de acompañamiento y desarrollo
            personal. No sustituye terapia psicológica, atención médica ni otros
            servicios profesionales de salud.
          </p>

          <p className="mt-6 text-[14px] text-ink-muted" data-id="element-98" data-mp="18w1nxfupohh5">
            © {new Date().getFullYear()} Careliz Griman · Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-99" data-mp="2rtmtc47oe91c">
        {openDoc && <LegalModal document={openDoc === 'terms' ? termsDocument : privacyDocument} onClose={() => setOpenDoc(null)} data-id="element-100" data-mp="2wmppmk3u7wl8" />}
      </AnimatePresence>
    </>;
}